/* eslint-disable func-names, max-len, no-new, no-underscore-dangle */
// Wait for all images to be loaded
$(window).load(() => {
  if ($('.oneKeyEqualRow').length > 0) {
    const equaliseHeights = function equaliseHeights() {
      let prodHeight = 0;
      const self = $('.oneKeyEqualRow');

      self.children('.oneKeyEqualHeight').each(function () {
        const childHeight = $(this).outerHeight();
        if (childHeight > prodHeight) {
          prodHeight = childHeight;
        }
      });

      self.children('.oneKeyEqualHeight').each(() => {
        self.children('.oneKeyEqualHeight').css('height', prodHeight);
      });
    };

    if ($(window).innerWidth() > 767) {
      equaliseHeights();
    }

    $(window).resize(() => {
      if ($(window).innerWidth() > 767) {
        equaliseHeights();
      }
    });
  }
});
